import { HTMLAttributes } from 'react';

import logoWhite from '../../assets/svg/logo-white.svg';
import logoPurple from '../../assets/svg/logo-purple.svg';
import logoBeta from '../../assets/svg/savings-club-beta-logo.svg';

interface LogoProps extends HTMLAttributes<HTMLImageElement> {
  variant?: 'primary' | 'secondary' | 'beta';
}

export const Logo = ({ variant = 'primary', ...props }: LogoProps) => {
  const variantMapper = {
    primary: logoPurple,
    secondary: logoWhite,
    beta: logoBeta,
  };

  return <img src={variantMapper[variant]} alt="Savings Club" {...props} />;
};
